import Alert from "react-bootstrap/Alert";
import { useSelector } from "react-redux";
import { getDisclaimer } from "@redux/selectors/verification-configuration-selectors";
import { getVerificationError } from "@redux/selectors/common-selectors";
import styles from "./disclaimer-container.less";

export const DisclaimerContainer = () => {
    const disclaimer = useSelector(getDisclaimer);
    const verificationError = useSelector(getVerificationError);
    
    if (!disclaimer) {
        return null;
    }

    return (
        <div className={styles.disclaimerContainer}>
            <span>{disclaimer}</span>

            {verificationError && (
                <Alert className={styles.warningAlert} variant="outlined-danger">
                    {verificationError}
                </Alert>
            )}
        </div>
    );
};